import { calculateRemainder } from '../../common/Utilities'
import { GESTION_OPERATIVA_SET_BON_ESPECIAL, GESTION_OPERATIVA_BON_ESPECIAL_ERROR, GESTION_OPERATIVA_SET_IS_MODIFIED } from './constants'
// import { SALE_TYPE } from 'common/Constants'

const moneyFormatter = new Intl.NumberFormat();

export function setBonEspecial(bonEspecial) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    // bonEspecial puede venir null o un valor
    const { gestionOperativa } = getState();
    const {maximoDescuento} = gestionOperativa;

    const usedCarBonif = gestionOperativa?.sale?.Taking_cars
      .reduce((total, tk) => total + (tk.take_improvement_amount || 0), 0) || 0

    const bonifMax = (gestionOperativa?.sale?.catalog_net_sale_price || 0) - usedCarBonif

    const remainder = calculateRemainder({
      discountNewVehicle: maximoDescuento.monto, 
      specialDiscount: gestionOperativa?.sale?.special_discount || 0,
      discountUsedVehicle: maximoDescuento.porcentaje, 
      takingCars: gestionOperativa.sale.Taking_cars,
      saleQuantity: gestionOperativa.sale.sale_quantity
    })

    maximoDescuento.remainder = remainder;
    
    if (bonEspecial > bonifMax && bonEspecial > 99) {
      dispatch({
        type: GESTION_OPERATIVA_BON_ESPECIAL_ERROR,
        data: {
          error: true,
          message: `El monto ingresado supera el límite de bonificación. Monto max: $${moneyFormatter.format(bonifMax)}`
        }
      })
    } else if (bonEspecial < 100 && bonEspecial > 0) {
      dispatch({
        type: GESTION_OPERATIVA_BON_ESPECIAL_ERROR,
        data: {
          error: true,
          message: 'El monto ingresado no puede ser menor a $100'
        }
      })
    } else {
      dispatch(
        dispatch({
          error: false,
          type: GESTION_OPERATIVA_SET_BON_ESPECIAL,
          data: bonEspecial
        }),
        dispatch({
          type: GESTION_OPERATIVA_SET_IS_MODIFIED,
          data: true
        })
      )
    }
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case GESTION_OPERATIVA_SET_BON_ESPECIAL:
      return {
        ...state,
        bonEspecialError: null,
        sale: {
          ...state.sale,
          special_discount: action.data
        },
        saveButtonDisabled: false,
      }
    case GESTION_OPERATIVA_BON_ESPECIAL_ERROR:
      return {
        ...state,
        bonEspecialError: action.data,
        saveButtonDisabled: true,
      }
    default:
      return state
  }
}